// extracted by mini-css-extract-plugin
export default {"wrapper":"RichText_wrapper__YL3Rz","content":"RichText_content__zflFr"};